<app-header-content-footer *transloco="let t"
                           [headerTitle]="t('home')">
  <app-sidenav-content content showBanner>
    <div content class="home-page">
      <app-score-area topHeader *ngIf="isMobile"></app-score-area>
      <app-quick-menu content></app-quick-menu>
      <app-opportunity-grid content></app-opportunity-grid>
    </div>
  </app-sidenav-content>
</app-header-content-footer>
